import { Chip, type ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { BaseUserRole } from '@/shared/api';

type Props = {
  role: BaseUserRole;
  shopName?: string | null;
};

const ROLE_COLORS: Partial<Record<BaseUserRole, ChipProps['color']>> = {
  admin: 'primary',
  service_advisor: 'secondary',
  technician: 'info',
};

const ROLE_LABEL_KEYS: Record<BaseUserRole, string> = {
  admin: 'roles.admin',
  shop_admin: 'roles.shopAdmin',
  shop_owner: 'roles.shopOwner',
  manager: 'roles.manager',
  technician: 'roles.technician',
  service_advisor: 'roles.serviceAdvisor',
  front_desk: 'roles.frontDesk',
  support_rep: 'roles.supportRep',
  system_admin: 'roles.systemAdmin',
};

export const UserRoleChip = ({ role, shopName }: Props) => {
  const { t } = useTranslation();
  const baseLabel = t(ROLE_LABEL_KEYS[role]);
  const label = shopName ? t('userRoleChip.labelWithShop', { role: baseLabel, shopName }) : baseLabel;
  const title = shopName ?? t('userRoleChip.systemWide');

  return <Chip label={label} size="small" color={ROLE_COLORS[role] ?? 'default'} variant="filled" title={title} />;
};
